import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "generationInProgress"
};
const _hoisted_2 = {
  key: 0,
  class: "giContent"
};
const _hoisted_3 = {
  class: "giTitle"
};
const _hoisted_4 = {
  class: "giSubtitle"
};
const _hoisted_5 = {
  key: 0,
  class: "giCurrentStep"
};
const _hoisted_6 = {
  class: "giElapsed"
};
const _hoisted_7 = {
  key: 1,
  class: "giContent"
};
const _hoisted_8 = {
  class: "giTitle"
};
const _hoisted_9 = {
  class: "giSubtitle"
};
const _hoisted_10 = {
  class: "giButtons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isGenerating ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_loader, {
    "spinner-size": "spinnersLarge"
  }), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.title')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.subtitle')), 1), _ctx.lastMessage ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.lastMessage), 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "giProgressBar"
  }, [_createElementVNode("div", {
    class: "giProgressIndeterminate"
  })], -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.elapsed', {
    time: _ctx.elapsedLabel
  })), 1)])) : _ctx.isError ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_icon, {
    icon: "alert-circle-outline",
    size: "huge",
    color: "danger"
  }), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.errorTitle')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.isTimeout ? _ctx.$t('aiSpeachGenerator.generationInProgress.timeoutMessage', {
    minutes: _ctx.timeoutMinutesNb
  }) : _ctx.$t('aiSpeachGenerator.generationInProgress.errorMessage')), 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_standard_button, {
    onAction: _ctx.relaunch,
    disabled: _ctx.busy
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "refresh"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.relaunch')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled"]), _createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.cancel,
    disabled: _ctx.busy
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.generationInProgress.cancel')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled"])])])) : _createCommentVNode("", true)]);
}